'use client'

import type { FieldSize } from './types'

import { createContext, useContext } from 'react'

import { FieldSize as FieldSizeEnum } from './types'

/**
 * Field size context for propagating size to children (labels, etc.)
 */
export const FieldSizeContext = createContext<FieldSize>(FieldSizeEnum.Medium)
FieldSizeContext.displayName = 'FieldSizeContext'

export function useFieldSize(): FieldSize {
  return useContext(FieldSizeContext)
}
